// extracted by mini-css-extract-plugin
export var dividerLine = "_51-0";
export var errorBackground = "_51-1";